export default function Hero() {
  return (
    <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden pt-[80px] md:pt-[100px] bg-black">
      <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, #f67f19 0%, transparent 50%), radial-gradient(circle at 80% 50%, #f67f19 0%, transparent 50%)' }}></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12 md:py-20">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-black text-white mb-4 md:mb-6 leading-tight">
          Get In Touch <span className="text-[#f67f19]">With Us</span>
        </h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto font-semibold leading-relaxed">
          Ready to get started? Contact us today for a free quote or emergency service
        </p>
      </div>
    </section>
  );
}
